
export const dutyReportToTemplateMapping = 
    // key is template id and value is report template route id
    {
        "wardSecurity" : {
            templateId: "67868e4a44e2e036f8eb5969",
            route: "/wardreport/"
        },
        "genericPatrol" : {
            templateId: "690b6259851a2cf51d57bb89",
            route: "/genericPatrol/"
        },
        "relayOnVPI" : {
            templateId: "66e71ea214797fc1f13c4472",
            route: "/relayOnVPI/"
        },
        "relayOnAlarm" : {
            templateId: "68915a08d38067ec91f053da",
            route: "/relayOnAlarm/"
        },
        "psgAlarm" : {
            templateId: "6a4ce957508ba6a155d2c191",
            route: "/psgAlarm/"
        }

    };


